/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-initiale[_ngcontent-%COMP%]{text-align:initial}.separator[_ngcontent-%COMP%]{border-top:1px solid #d3d3d3}"];
export { styles as styles };
